import React, { useState, useCallback, useRef } from "react";
import FormSkel from "../../../../../components/Modals/FormSkel";

const TemperatureForm = ({ isOpen, onClose, onSubmit, generateTaskId }) => {
  const [temperatureValue, setTemperatureValue] = useState("");
  const [startAt, setStartAt] = useState("");
  const [error, setError] = useState("");

  const taskIdRef = useRef(null);

  const handleValueChange = useCallback((val) => {
    setTemperatureValue(val);
    if (val === "" || val === null || val === undefined) {
      setError("Proszę podać wartość temperatury.");
      return;
    }
    const numVal = Number(val);
    if (isNaN(numVal)) {
      setError("Temperatura musi być liczbą.");
    } else if (numVal < -90 || numVal > 100) {
      setError("Temperatura musi mieścić się w przedziale od -90°C do 100°C.");
    } else {
      setError("");
    }
  }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    if (!temperatureValue) {
      setError("Proszę podać wartość temperatury.");
      return;
    }

    const numVal = Number(temperatureValue);
    if (isNaN(numVal) || numVal < -90 || numVal > 100) {
      setError("Temperatura musi mieścić się w przedziale od -90°C do 100°C.");
      return;
    }

    const task = {
      id: generateTaskId(),
      taskType: "TEMPERATURE",
      value: temperatureValue,
      startAt: startAt || null,
      datetimeType: startAt ? "single" : null,
      disableReccuring: false,
    };

    taskIdRef.current = task.id; 
    onSubmit(task);

    setStartAt("");
    setTemperatureValue("");
    setError("");
  }, [temperatureValue, startAt, onSubmit, generateTaskId]);

  const handleClose = useCallback(() => {
    setStartAt("");
    setTemperatureValue("");
    setError("");
    onClose();
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <FormSkel headerText="Zmiana temperatury na automacie" handleClose={handleClose} acceptForm="true">
      <div>
        <form onSubmit={handleSubmit} id="modal-form">
          <div className="form-group">
            <label htmlFor="value" className="form-label font-weight-bold">
              Docelowa temperatura (°C)
            </label>
            <input
              type="number"
              className={`form-control ${error ? 'is-invalid' : temperatureValue ? 'is-valid' : ''}`}
              id="value"
              name="value"
              value={temperatureValue}
              onChange={(e) => handleValueChange(e.target.value)}
              placeholder="np. 5"
              step="0.1"
              required
            />
            {error ? (
              <div className="invalid-feedback d-block text-danger font-weight-bold mt-1">
                {error}
              </div>
            ) : (
              <small className="form-text text-muted">
                Dopuszczalny zakres: <strong>-90°C</strong> do <strong>100°C</strong>
              </small>
            )}
          </div>

          <div className="form-group mb-0">
            <label htmlFor="datetimeChange" className="form-label font-weight-bold">
              Kiedy wykonać zmiane (opcjonalnie)
            </label>
            <input
              type="datetime-local"
              className="form-control"
              id="datetimeChange"
              value={startAt}
              onChange={(e) => setStartAt(e.target.value)}
            />
            <small className="form-text text-muted">
              Pozostaw puste dla natychmiastowego wykonania.
            </small>
          </div>
        </form>
      </div>
    </FormSkel>
  );
};

export default TemperatureForm;
